import { makeStyles } from '@mui/styles';
const useAppfolioPushStyles = makeStyles({
  messages: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginTop: '12px'
  },
  blockerList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '12px',
    borderRadius: '8px',
    backgroundColor: '#fdf3f2'
  },
  blockerTitle: {
    fontWeight: 600
  },
  blockerDetail: {
    marginTop: '2px'
  }
});
export default useAppfolioPushStyles;